import { Controller } from "@hotwired/stimulus"

// Updates the board digest "email template" description when a different
// template is selected, mirroring the task automations notification config.
export default class extends Controller {
  static targets = ["select", "description"]

  changed() {
    if (!this.hasDescriptionTarget) return

    const descriptions = JSON.parse(this.descriptionTarget.dataset.descriptions || "{}")
    this.descriptionTarget.textContent = descriptions[this.selectTarget.value] || ""
  }
}
